import { AnalyticsTypeOfActivePassiveItemService } from "./../../../services/catalogs/AnalyticsTypeOfActivePassiveItemService";
import { AnalyticsTypeOfIncomeExpenseItemDetail } from "./../../../components/Pages/Catalogs/AnalyticsTypeOfIncomeExpenseItem/AnalyticsTypeOfIncomeExpenseItemDetail";
import { CreateBankDto } from "./../../../dtos/catalogs/bank/CreateBankDto";
import { BankDetail } from "./../../../components/Pages/Catalogs/bank/BankDetail";
import { BankAccountService } from "../../../services/catalogs/BankAccountService";
import React from "react";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { CreateAnalyticsTypeOfIncomeExpenseItemDto } from "../../../dtos/catalogs/AnalyticsTypeOfIncomeExpenseItem/CreateAnalyticsTypeOfIncomeExpenseItemDto";
import { NFLookupAnalyticsTypeOfIncomeExpenseItem } from "../../../components/Shared/NewForms/NFLookupAnalyticsTypeOfIncomeExpenseItem";
import AnalyticsTypeOfIncomeExpenseItemList from "../../../components/Pages/Catalogs/AnalyticsTypeOfIncomeExpenseItem/AnalyticsTypeOfIncomeExpenseItemList";

export const AnalyticsTypeOfIncomeExpenseItem: IAppEntity = {
  entityType: "catalog",
  title: "Analytics Type Of Income Expense Item",
  pluralTitle: "Analytics Type Of Income Expense Item",
  apiUrl: "AnalyticsTypeOfIncomeExpenseItems",
  apiEnum: ReferenceTypes.CatalogAnalyticsTypeOfActivePassiveItem,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(AnalyticsTypeOfIncomeExpenseItemDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(AnalyticsTypeOfIncomeExpenseItemList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupAnalyticsTypeOfIncomeExpenseItem, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new AnalyticsTypeOfActivePassiveItemService(this.apiUrl);
  },
  getEmptyModel(): CreateAnalyticsTypeOfIncomeExpenseItemDto {
    return {
      name: "",
      createdDate: new Date(),
      description: "",
      itemType: 0,
    };
  },
};
// "name": "string",
//     "uniqueCode": "string",
//     "createdDate": "2023-01-11T09:38:51.644Z",
//     "description": "string",
//     "itemType": 0,
